module.exports = __webpack_public_path__ + "img/hoodie-front.9e356230.svg";